export enum PrimasDropdownFilterOperator {
    Contains = "Contains",
    DoesNotContains = "Does Not Contains",
}
export enum PrimasBooleanFilterOperator {
    Contains = "Contains",
    DoesNotContains = "Does Not Contains",
}
